module.exports = __webpack_public_path__ + "static/media/a.49fee37d.png";